import { AfterViewInit, Component, ComponentRef, ViewContainerRef, DOCUMENT, inject } from "@angular/core";
import { SettingsIntegrationsSidebarSMTPComponent } from "@app/features/settings/sidebar/smtp.component";
import { sidebarMobileLocalItemKey } from "@config/config";
import { UserService } from "@app/shared/_services/user.service";

import { SettingsService } from "@app/features/settings/settings.service";
import { VerifiedDomainsSidebarComponent } from "@app/shared/_components/verified-domains/verified-domains.sidebar.component";
import { DataLocationModalComponent } from "@app/shared/_components/data-location-modal/data-location-modal.component";
import { FirstLoginWizardComponent } from "@app/shared/_components/first-login-wizard/first-login-wizard.component";
import { User } from "@app/shared/_interfaces/user";
import { Router, RouterOutlet } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { ToastModule } from "primeng/toast";
import { NgClass } from "@angular/common";
import { TdSidebarMenuDirective } from "../../_directives/tdsidebarmenu.directive";
import { AppSidebarMenuComponent } from "../app-sidebar-menu/app-sidebar-menu.component";
import { AppSigninHeaderComponent } from "../app-signin-header/app-signin-header.component";
import { MessageModule } from "primeng/message";
import { AppSigninFooterComponent } from "../app-signin-footer/app-signin-footer.component";
import { TranslatePipe } from "../../_pipes/translate.pipe";

@Component({
    selector: "app-general-layout",
    templateUrl: "./general-layout.component.html",
    styleUrls: ["./general-layout.component.scss"],
    imports: [ToastModule, NgClass, TdSidebarMenuDirective, AppSidebarMenuComponent, AppSigninHeaderComponent, MessageModule, RouterOutlet, AppSigninFooterComponent, TranslatePipe]
})
export class GeneralLayoutComponent implements AfterViewInit {
  private viewContainerRef = inject(ViewContainerRef);
  private settingsService = inject(SettingsService);
  private cookieService = inject(CookieService);
  private _userService = inject(UserService);
  private _router = inject(Router);
  private document = inject<Document>(DOCUMENT);

  private componentRef: ComponentRef<any>;
  isMobile: boolean;
  isSubaccount: boolean;
  lang: string;
  hasLegacyKey: boolean;
  private firstLoginWizard: boolean;
  private profileCompleted: boolean;
  private disabledTooltips: User.Info["disabled_tooltips"] = [];

  constructor() {
    this.isMobile = this.checkIsMobile();
    this.isSubaccount = this._userService.getInfoValue(
      "is_subaccount",
    ) as boolean;
    this.hasLegacyKey = this._userService.getInfoValue(
      "has_legacy_api_key",
    ) as boolean;
    // @TODO remove after migration
    // this.hasLegacyKey = false;
    this.disabledTooltips = this._userService.getInfoValue(
      "disabled_tooltips",
    ) as User.Info["disabled_tooltips"];

    this.lang = this._userService.getInfoValue("lang");
    this.document.documentElement.lang = this.lang;
    this.profileCompleted =
      this.cookieService.get("kc-profile-completed") === "yes";
    this.firstLoginWizard =
      !this.hasLegacyKey &&
      !this.disabledTooltips.includes("has_legacy_api_key");
    // @TODO remove after migration
    // this.firstLoginWizard = true;

    if (this.lang === "ar") {
      this.document.documentElement.dir = "rtl";
    }
  }

  private checkIsMobile() {
    return (
      this._userService.getLocalStorageItem(sidebarMobileLocalItemKey) ===
        "yes" || false
    );
  }

  openSidebar(sidebar: "smtp_settings" | "dns_settings") {
    if (sidebar === "smtp_settings") {
      this.settingsService.openSidebarSettings(
        this.viewContainerRef,
        SettingsIntegrationsSidebarSMTPComponent,
      );
    } else {
      this.settingsService.openSidebarSettings(
        this.viewContainerRef,
        VerifiedDomainsSidebarComponent,
      );
    }
  }

  setIsMobile() {
    this._userService.setLocalStorageItem(
      sidebarMobileLocalItemKey,
      this.checkIsMobile() ? "no" : "yes",
    );
    this.isMobile = this.checkIsMobile();
  }

  ngAfterViewInit() {
    if (this.firstLoginWizard || this.profileCompleted) {
      this.openFirstLoginWizard(true);
    }
  }

  openFirstLoginWizard(open: boolean) {
    if (open) {
      this.componentRef = this.viewContainerRef.createComponent(
        FirstLoginWizardComponent,
      );

      this.componentRef.setInput('profileCompleted', this.profileCompleted);
      this.componentRef.setInput('showWizardSteps', this.firstLoginWizard);
      this.componentRef.instance.visible.set(true);
      this.componentRef.instance.visible.subscribe((visible) => {
        if (!visible) {
          this.componentRef.destroy();
        }
      });
    }
  }

  openDataLocationSidebar(open: boolean) {
    if (open) {
      this.componentRef = this.viewContainerRef.createComponent(
        DataLocationModalComponent,
      );

      this.componentRef.instance.visible.set(true);
      this.componentRef.instance.visible.subscribe((visible) => {
        if (!visible) {
          this.componentRef.destroy();
        }
      });
    }
  }
}
